import ResponseError from "../axios/ResponseError";

export const handleError = (error: any) => {
  const statusCode = error.response.data.statusCode;
  const message = error.response.data.message;

  throw new ResponseError({ statusCode, message });
}
